import React from "react";
import { Tabs, Tab, Box, Tooltip } from "@mui/material";
import "./InvoiceTabs.css";

function InvoiceTabs({ value, onChange }) {
  return (
    <Box className="tabs-wrapper">
      <Tabs
        value={value}
        onChange={onChange}
        variant="scrollable"
        scrollButtons="auto"
        className="custom-tabs"
      >
        <Tooltip
          title="Invoices that have been generated but not yet marked as paid."
          arrow
          placement="bottom"
        >
          <Tab className="custom-tab" label="New Invoice" />
        </Tooltip>
        <Tooltip
          title="Invoices that have been fully paid by the user or Payment from customer pending reconciliation with corresponding invoices are listed here."
          arrow
          placement="bottom"
        >
          <Tab className="custom-tab" label="Payment" />
        </Tooltip>

        <Tooltip
          title="Invoices past their due date that are still unpaid."
          arrow
          placement="bottom"
        >
          <Tab className="custom-tab" label="Overdue" />
        </Tooltip>
      </Tabs>
    </Box>
  );
}

export default InvoiceTabs;
